// extracted by mini-css-extract-plugin
export default {"products":"rz-z","card":"sz-z","oosMessaging":"tz-z"};